import moment from "moment";
import React, { useMemo } from "react";
import { OrderProductType } from "../../../../controller/OrderController";
import {
  KnockOrderItemType,
  RIDER_ALLOCATION_CANCELED,
} from "../../../../recoil/type";
import { getRiderComment } from "../../../../utils/StatusComment";
import ButtonStatus from "../Button/ButtonStatus";

// 주문 내용 (간단히보기)

type OrderInfoProps = {
  order: KnockOrderItemType;
  isBlink: boolean;
  isDetail: boolean;
  index: number;
  setBlinkCount: (blinkCount: number) => void;
};

const OrderInfo = ({
  order,
  isBlink,
  isDetail,
  index,
  setBlinkCount,
}: OrderInfoProps) => {
  const getTotalQuantity = () => {
    let totalQuantity = 0;
    order.child.detail.map((item: OrderProductType) => {
      totalQuantity += item.product_quantity;
    });
    return totalQuantity;
  };
  const getMenuListString = () => {
    let menuString = "";
    order.child.detail.map((item: OrderProductType) => {
      menuString += `${item.product_name} ${item.product_quantity}개 /`;
    });
    menuString = menuString.slice(0, -1);
    return menuString;
  };

  const OrderInfo = useMemo(() => {
    return (
      <div className="orderList">
        {/* 주문타입 및 시간 */}
        <div className="listLeft">
          <div>
            <h1>{moment(new Date(order.child.ordered_at)).format("HH:mm")}</h1>
            <p>
              {order.child.bill_number}
              {/* {order.child.delivery_type} */}
            </p>
          </div>
          <div>
            <h2 className={`orderType delivery`}>배달</h2>
            <p>{order.child.delivery_address_detail}</p>
          </div>
          {order.delivery_info && (
            <div
              className={`deliveryBadge ${
                order.delivery_info.deliveryStatus ===
                  RIDER_ALLOCATION_CANCELED && "cancel"
              }`}
            >
              <p>
                {getRiderComment(
                  order.app_name,
                  order.delivery_info.deliveryStatus
                )}
              </p>
            </div>
          )}
        </div>

        {/* 주문정보 */}
        <div className="listCenter">
          <div className="detailListWrap">
            <div className="flexItem title">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_knock_logo.svg`}
                alt="img"
              />
            </div>
            <h2 className="flexItem">{getTotalQuantity()}개</h2>
            <h2 className="flexItem right">
              {(
                order.child.total_amount_incl - order.child.room_tip
              ).toLocaleString()}
              원
            </h2>
          </div>
          <h3>{getMenuListString()}</h3>
          <h3 className={`requestText ${isDetail ? "detail" : ""}`}>
            {order.child.inquiry}
          </h3>
        </div>

        {/* status변경 버튼 */}
        <ButtonStatus
          props={order}
          isBlink={isBlink}
          setBlinkCount={setBlinkCount}
          index={index}
        />
      </div>
    );
  }, [order, isBlink]);

  return OrderInfo;
};

export default OrderInfo;
